/**
 * Community 社区的状态管理
 */
import ROUTER from '../../router.js'
import { GET, URLS, POST, DELETE, PUT, Utils, GET_VALUE, SET_VALUE } from '../../utils'
import { types as TipTypes } from './tip'
import { types as LoadingTypes } from './loading'
import { types as ToastTypes } from './toast'
import { types as ConfirmTypes } from './confirm'
import { types as LoginTypes } from './login'
import { resolve, reject } from 'core-js/fn/promise'

export const types = {
  /**
   * 帖子列表请求
   */
  FETCH_LIST_POST: 'COMMUNITY/FETCH_LIST_POST',

  /**
   * 新建事件请求(帖子、评论、回复)
   */
  FETCH_CREATE_EVENT: 'COMMUNITY/FETCH_CREATE_EVENT',

  /**
   * 点赞请求(帖子、评论、回复)
   */
  FETCH_LIKE_EVENT: 'COMMUNITY/FETCH_LIKE_EVENT',

  /**
   * 删除事件(帖子、评论、回复)
   */
  FETCH_DELETE_EVENT: 'COMMUNITY/FETCH_DELETE_EVENT',

  /**
   * 送花请求
   */
  FETCH_FLOWER_EVENT: 'COMMUNITY/FETCH_FLOWER_EVENT',

  /**
   * 转发帖子到朋友圈
   */
  FETCH_FORWARD_EVENT: 'COMMUNITY/FETCH_FORWARD_EVENT',

  /**
   * 关注/取关请求
   */
  FETCH_FOLLOWERS_EVENT: 'COMMUNITY/FETCH_FOLLOWERS_EVENT',

  /**
   * 帖子详情请求
   */
  FETCH_POST_DETAIL: 'COMMUNITY/FETCH_POST_DETAIL',

  /**
   * 帖子置顶请求
   */
  FETCH_STICKY_EVENT: 'COMMUNITY/FETCH_STICKY_EVENT',

  /**
   * 帖子加精请求
   */
  FETCH_ESSENCE_EVENT: 'COMMUNITY/FETCH_ESSENCE_EVENT',

  /**
   * 视频帖子上首页
   */
  FETCH_HOME_VIDEO_EVENT: 'COMMUNITY/FETCH_HOME_VIDEO_EVENT',

  /**
   * 评论列表请求
   */
  FETCH_COMMENT_LIST: 'COMMUNITY/FETCH_COMMENT_LIST',

  /**
   * 社区每天时间限制请求
   */
  FETCH_DAY_PLAY_TIME: 'COMMUNITY/FETCH_DAY_PLAY_TIME',

  /**
   * 社区出题请求
   */
  FETCH_CREATE_QUESTION: 'COMMUNITY/FETCH_CREATE_QUESTION',

  /**
   * 社区答题请求
   */
  FETCH_ANSWER_QUESTION: 'COMMUNITY/FETCH_ANSWER_QUESTION',

  /**
   * 距离上次浏览帖子，后新增的帖子的数请求
   */
  FETCH_NEW_ADD_POST_COUNT: 'COMMUNITY/FETCH_NEW_ADD_POST_COUNT',

  /**
   * 回复列表
   */
  FETCH_REPLY_LIST: 'COMMUNITY/FETCH_REPLY_LIST',

  /**
   * 判断是否可以发帖请求
   */
  FETCH_IS_CAN_SEND: 'COMMUNITY/FETCH_IS_CAN_SEND',

  // 获取个人勋章列表
  FETCH_MY_MEDALS:'COMMUNITY/FETCH_MY_MEDALS',

  // 帖子列表请求结果的处理
  LIST_POST: 'COMMUNITY/LIST_POST',
  // 帖子列表数据源前面追加单条帖子数据
  LIST_POST_ADD_BEFORE: 'COMMUNITY/LIST_POST_ADD_BEFORE',
  // 帖子列表请求分页数据处理
  PAGE_ADD_ONE: 'COMMUNITY/PAGE_ADD_ONE',
  // 帖子列表请求是否还有数据的处理
  UPDATE_LOAD_MORE: 'COMMUNITY/UPDATE_LOAD_MORE',
  // 点赞回调处理事件
  LOAD_LIKE_EVENT: 'COMMUNITY/LOAD_LIKE_EVENT',
  // 删除回调处理事件
  LOAD_DELETE_EVENT: 'COMMUNITY/LOAD_DELETE_EVENT',
  // 送花回调处理事件
  LOAD_FLOWER_EVENT: 'COMMUNITY/LOAD_FLOWER_EVENT',
  // 获取个人勋章列表回调处理
  LOAD_MY_MEDALS:'COMMUNITY/LOAD_MY_MEDALS',
  // 更新帖子类型
  UPDATE_POST_TYPE: 'COMMUNITY/UPDATE_POST_TYPE',
  // 更关注类型
  UPDATE_FOLLOW_TYPE: 'COMMUNITY/UPDATE_FOLLOW_TYPE',
  // 更新圈子未读数
  UPDATE_NEW_POST_COUNT: 'COMMUNITY/UPDATE_NEW_POST_COUNT',
  /**
   * 关注/取关回调处理事件
   */
  LOAD_FOLLOWER_EVENT: 'COMMUNITY/LOAD_FOLLOWER_EVENT',
  // 帖子列表数据源处理(时间等)后使用
  GETTER_LIST_POST: 'COMMUNITY/GETTER_LIST_POST'
}

const state = {
  posts: [], // 帖子列表
  page: 1, // 当前请求页面
  page_size: 10, // 一页请求多少条数据
  load_more: false, // 是否还有数据未加载
  myposts: [],
  post_type: null, // 记录帖子的类型，便于创建评论/回复时，直接刷新页面获取列表.
  follow_type: null, // 记录关注的类型，便于创建评论/回复时，直接刷新页面获取列表.

  // 某个帖子的详情数据
  current_post: null,
  // 评论数据
  comment_data: null,

  // 回复数据
  reply_data: null,

  // 数据(用于监听的数据)
  watch_create_data:null,
  watch_zan_data: null,
  watch_delete_data: null,
  watch_flower_data: null,
  watch_follow_data: null,

  reply:{
    page:1,
    page_size:10,
    load_more:false,
    data:[],
    total_count:0,
  },

  
  // 当天限时游玩时间
  day_play_time: null,
  // 距离上次浏览帖子，后新增的帖子条数
  new_post_count:{
    "common_post_count":0, 
    "work_post_count":0,
    "active_post_count":0,
    "science_post_count":0,
    "move_post_count":0,
    "mago_post_count": 0,
    "cube_post_count":0,
    "contest_post_count":0,
    "oj_post_count":0,
    "company_count":0,
    "video_post_count":0,
    "piskel_post_count":0,
    "school_count":0,
    "lego_post_count":0
  },

  // 监听是否可以发帖
  watch_can_send:null,

  // 个人勋章
  my_medals_count: 0,
  my_medals_list: []
}

const mutations = {
  /**
   * 处理帖子列表数据
   * @param {*} state
   * @param {*} param [ 帖子数组 ]
   */
  [types.LIST_POST] (state, param) {
    if (state.page !== 1) {
      state.posts = state.posts.concat(param)
    } else {
      state.posts = param
    }
  },
  /**
   * 帖子列表分页+1
   * @param {*} state
   * @param {*} param_data ["next"、"reset""]
   */
  [types.PAGE_ADD_ONE] (state, param_data) {
    if (param_data === 'next') {
      state.page = state.page + 1
    } else {
      state.page = 1
    }
  },
  /**
   * 帖子列表是否还有更多数据
   * @param {*} state
   * @param {*} param
   */
  [types.UPDATE_LOAD_MORE] (state, param) {
    state.load_more = param
  },
  // 新建帖子，刷新数据源【帖子列表】
  [types.LIST_POST_ADD_BEFORE] (state, param) {
    state.posts.unshift(param)
  },
  // 点赞帖子、评论、回复，刷新相关数据事件【帖子列表、当前帖子】
  [types.LOAD_LIKE_EVENT] (state, param) {
    let type = param.type
    let pk = param.pk
    let posts = state.posts
    if (ROUTER.currentRoute.name === 'post_detail') {
      posts = [state.current_post]
    }
    if (type === 'post') {
      mutations.findTargetItem(posts, pk)
    } else if (type === 'comment') {
      posts.map((item, index) => {
        mutations.findTargetItem(item.comments, pk)
      })
    } else if (type === 'reply') {
      posts.map((item, index) => {
        item.comments.map((commentItem, index) => {
          mutations.findTargetItem(commentItem.replys, pk)
        })
      })
    }
  },
  // 删除帖子、评论、回复，刷新相关数据事件【帖子列表、当前帖子】
  [types.LOAD_DELETE_EVENT] (state, param) {
    let type = param.type
    let pk = param.pk
    let posts = state.posts
    if (ROUTER.currentRoute.name === 'post_detail') {
      posts = [state.current_post]
    }
    let arr = posts
    if (type === 'post') {
      arr = posts.filter(item => {
        return item.pk !== pk
      })
    } else if (type === 'comment') {
      arr = posts.map((item, index) => {
        let the_comment = item.comments.find(commentItem => commentItem.pk === pk)
        let comments = item.comments.filter(commentItem => {
          return commentItem.pk !== pk
        })
        item['comments'] = comments

        if (the_comment) {
          item['real_comment_count'] -= 1
          item['comment_count'] -= 1 + the_comment.replys.length
        }
        return item
      })
    } else if (type === 'reply') {
      arr = posts.map((item, index) => {
        let count = 0;
        let comments = item['comments'].map(commentItem => {
          let the_reply = commentItem['replys'].find(replyItem => replyItem.pk === pk)
          let replys = commentItem['replys'].filter(replyItem => {
            return replyItem.pk !== pk
          })
          commentItem['replys'] = replys
          if(the_reply){
            commentItem['reply_count'] -= 1
            count += 1
          }
          return commentItem
        })
        item['comments'] = comments
        item['comment_count'] -= count;
        return item
      })
    }
    if (ROUTER.currentRoute.name === 'post_detail') {
      state.current_post = arr[0] ? arr[0] : null
    } else {
      state.posts = arr
    }
  },
  // 送花帖子、评论、回复，刷新相关数据事件【帖子列表、当前帖子】
  [types.LOAD_FLOWER_EVENT] (state, param) {
    let type = param.type
    let pk = param.pk
    let posts = state.posts
    if (ROUTER.currentRoute.name === 'post_detail') {
      posts = [state.current_post]
    }
    if (type === 'post') {
      mutations.flowerDataDeal(posts, pk)
    } else if (type === 'comment') {
      posts.map((item, index) => {
        mutations.flowerDataDeal(item.comments, pk)
      })
    } else if (type === 'reply') {
      posts.map((item, index) => {
        item.comments.map((commentItem, index) => {
          mutations.flowerDataDeal(commentItem.replys, pk)
        })
      })
    }
  },
  // 关注用户，刷新相关数据事件【帖子列表、当前帖子，评论，个人主页】
  [types.LOAD_FOLLOWER_EVENT] (state, param) {
    let followers = param.followers
    let posts = state.posts
    if (ROUTER.currentRoute.name === 'post_detail') {
      posts = [state.current_post]
    }
    let arr = posts
    arr = posts.map((item, index) => {
      if (followers.includes(item.owner.user)) {
        item['is_follow'] = !item.is_follow
      }

      let comments = item.comments
      comments = comments.map(commentItem => {
        if (followers.includes(commentItem.owner.user)) {
          commentItem['is_follow'] = !commentItem.is_follow
        }

        let replys = commentItem.replys
        replys = replys.map(replyItem => {
          if (followers.includes(replyItem.owner.user)) {
            replyItem['is_follow'] = !replyItem.is_follow
          }
          return replyItem
        })
        return commentItem
      })
      return item
    })
    if (ROUTER.currentRoute.name === 'post_detail') {
      state.current_post = arr[0] ? arr[0] : null
    } else {
      state.posts = arr
    }
  },
  [types.UPDATE_POST_TYPE] (state, param) {
    state.post_type = param
  },
  [types.UPDATE_FOLLOW_TYPE] (state, param) {
    state.follow_type = param
  },

  // 设置当前帖子数据
  setCurrentPost (state, param) {
    state.current_post = param
  },
  // 设置评论数据
  setCommentData (state, param) {
    // 不知道为什么，这里的评论数据刷新不起作用，暂时搬到页面自行处理
    // 更新某贴的评论数据
    state.comment_data = param
    // 帖子列表[更新某个贴子下的评论列表]
    let target_postItem = state.posts.find(postItem=>postItem.pk === param.pk)
    if(target_postItem){
      if(param.page === 1){
        target_postItem["comments"] = param.results
      }else{
        target_postItem["comments"] = target_postItem["comments"].concat(param.results)
      }
    }

    // 更新当前帖子的评论列表
    if(state.current_post && state.current_post.pk === param.pk){
      if(param.page === 1){
        state.current_post["comments"] = param.results
      }else{
        state.current_post["comments"] = state.current_post["comments"].concat(param.results)
      }
    }
  
  },
  // 追加评论数据
  unshiftCommentData(state, param){
    let temp_data = ROUTER.currentRoute.name === 'post_detail' ? [state.current_post] : state.posts
    let target_postItem = temp_data.find(postItem=>postItem.pk === param.pk)
    if(target_postItem){
      target_postItem["comments"].unshift(param.data)
      target_postItem["real_comment_count"] += 1
      target_postItem["comment_count"] += 1
    }
  },
  // 追加回复数据
  unshiftReplyData(state, param){
    let post_id = param.post_id
    let comment_id = param.comment_id
    let temp_data = ROUTER.currentRoute.name === 'post_detail' ? [state.current_post] : state.posts
    let target_postItem = temp_data.find(postItem=>postItem.pk === post_id)
    if(target_postItem){
      let target_commentItem = target_postItem.comments.find(commentItem=>commentItem.pk === comment_id)
      if(target_commentItem){
        target_commentItem["replys"].unshift(param.data)
        target_postItem["comment_count"] += 1
      }
    }
  },


  // 设置回复数据
  setReplyData(state, param){
    state.reply_data = param
  },
  // --------设置监听数据
  // 新增评论，新增回复
  set_watch_create_data(state, param){
    state.watch_create_data = param
  },
  // 点赞评论，点赞回复
  set_watch_zan_data(state, param){
    state.watch_zan_data = param
  },
  // 删除回复，删除评论
  set_watch_delete_data(state, param){
    state.watch_delete_data = param
  },
  // 送花评论，送花回复
  set_watch_flower_data(state, param){
    state.watch_flower_data = param
  },
  // 关注评论，关注回复
  set_watch_follow_data(state, param){
    state.watch_follow_data = param
  },

  // 是否可以发送
  set_watch_can_send(state, param){
    state.watch_can_send = param;
  },

  // ---测试(回复加载更多)
  set_load_more (state, param) {
    // param: {"value": true, "data_type":"member"}
    state.reply.load_more = param.value
  },
  set_pagenum (state, param) {
    // param: {"value": 3, "data_type":"member"}
    state.reply.page = param.value
  },
  set_list_data (state, param) {
    // param: {"data": [], "data_type":"member"}
    let temp_state = state.reply;
    
    if(temp_state){
      if (temp_state.page === 1) {
        temp_state.data = param.data
      } else {
        temp_state.data = temp_state.data.concat(param.data)
      }
      temp_state.total_count = param.count

      // 更改相关数据源
      let temp_data = state.posts
      if (ROUTER.currentRoute.name === 'post_detail') {
        temp_data = [state.current_post]
      } 

      temp_data = temp_data.map((item, index) => {
        let targete_item = item.comments.find(commentItem=>commentItem.pk === param.comment_id)
        if(targete_item){
          targete_item["replys"] = temp_state.data
        }
      })
      
    }

  },

  // 设置每日游玩时间
  setDayPlayTime (state, param) {
    state.day_play_time = param
  },
  // 更新置顶状态
  updateListSticky (state, param) {
    let posts = state.posts
    if (ROUTER.currentRoute.name === 'post_detail') {
      posts = [state.current_post]
    }

    let target_item = posts.find(item => item.pk === param.pk)
    if(target_item){
      target_item['is_top'] = !target_item.is_top
    }
  },
  // 更新加精状态
  updateListEssence(state, param){
    let posts = state.posts
    if (ROUTER.currentRoute.name === 'post_detail') {
      posts = [state.current_post]
    }

    let target_item = posts.find(item => item.pk === param.pk)
    if(target_item){
      target_item['is_essence'] = !target_item.is_essence
    }
  },
  // 更新视频帖子上首页状态
  updateListHomeVideo(state, param){
    let posts = state.posts
    if (ROUTER.currentRoute.name === 'post_detail') {
      posts = [state.current_post]
    }

    let target_item = posts.find(item => item.pk === param.pk)
    if(target_item){
      target_item['is_home_video'] = !target_item.is_home_video
    }
  },
  // 更新列表中的某个帖子数据
  update_some_post_list (state, param) {
    let target_item = state.posts.find((item) => item.pk === parseInt(param.post_id))
    if (target_item) {
      target_item["answer_count"] = target_item["answer_count"] + 1
      if (param.is_right) {
        target_item["answer_right_count"] = target_item["answer_right_count"] + 1
      }
      target_item["answer_record"] = param;
    }
  },
  // 设置新增帖子条数
  setNewPostCount (state, param) {
    state.new_post_count = {...state.new_post_count, ...param}
  },

  // ---------mutation 中的帮助方法
  // 点赞数据处理
  findTargetItem (data, pk) {
    let target_item = data.find((item, index) => {
      return item.pk === pk
    })
    if (target_item) {
      if (target_item.is_like === true) {
        target_item['is_like'] = false
        target_item['like_count'] -= 1
      } else {
        target_item['is_like'] = true
        target_item['like_count'] += 1
      }
    }
  },
  // 送花数据处理
  flowerDataDeal (data, pk) {
    let target_item = data.find((item, index) => {
      return item.pk === pk
    })
    if (target_item) {
      if (target_item.is_flower === true) {
        target_item['is_flower'] = false
        target_item['flower_count'] -= 1
      } else {
        target_item['is_flower'] = true
        target_item['flower_count'] += 1
      }
    }
  },

  [types.UPDATE_NEW_POST_COUNT](state, param){
    state.new_post_count = {...state.new_post_count, ...param}
  },

  [types.LOAD_MY_MEDALS] (state, dic){
    state.my_medals_list = dic.results
    state.my_medals_count = dic.count
  }

}

const actions = {
  /**
   * 帖子列表
   * @param { Object } param_data {"type":"next", "post_type":"common", "user_id":"1", "owner":"1520011111", "follow_type":'all'}
   */
  [types.FETCH_LIST_POST] (
    { dispatch, commit, state, rootState, rootGetter },
    param_data
  ) {
    let type = param_data.type
    let from = param_data.from

    commit(LoadingTypes.SHOW)
    commit(types.UPDATE_LOAD_MORE, false)
    if (type === 'next') {
      // 下一页数据
      commit(types.PAGE_ADD_ONE, type)
    } else if (type === 'reset') {
      // 刷新本页数据，即重新请求第一页数据
      commit(types.PAGE_ADD_ONE, type)
    }

    let post_type = param_data.post_type ? param_data.post_type : null
    let follow_type = param_data.follow_type ? param_data.follow_type : null
    let user_id = param_data.user_id ? param_data.user_id : null
    let owner = param_data.owner ? param_data.owner : null
    let company_id = param_data.company_id ? param_data.company_id : null
    let search = param_data.search ? param_data.search : null
    let is_essence = param_data.is_essence ? param_data.is_essence : null
    let school_id = param_data.school_id ? param_data.school_id : null
    let page_size = param_data.page_size ? param_data.page_size : null

    user_id = ROUTER.currentRoute.params.user ? ROUTER.currentRoute.params.user : null
    // 当前所处的圈子名
    let circle_tag = ROUTER.currentRoute.query.tag ? ROUTER.currentRoute.query.tag : 'scratch';
    let route_name = ROUTER.currentRoute.name;
    //console.log("circle_tag"+circle_tag+" route_name"+route_name+" post_type"+post_type)
    // 这里记录一下帖子类型和关注类型，以便后续评论或者转发时刷新列表
    commit(types.UPDATE_POST_TYPE, post_type)
    commit(types.UPDATE_FOLLOW_TYPE, follow_type)

    var url = URLS.list_post(state.page, post_type, user_id, owner, follow_type, company_id, search, is_essence, school_id, page_size)

    GET(url).then(response => {
      // var arr = loadData();
      var arr = response.results
      if (response.next) {
        commit(types.UPDATE_LOAD_MORE, true)
      } else {
        commit(types.UPDATE_LOAD_MORE, false)
      }
      arr = arr.map(item=>{
        item["comments"] = []
        return item
      })
      commit(types.LIST_POST, arr)
      commit(LoadingTypes.HIDE)
      if (route_name === "home") {
        // 如果是朋友圈或者作品圈，存一下最新的帖子 id，并刷新新增个数
        if (state.page === 1 && arr.length) {
          let last_post = arr.reduce((preVal, curVal) => {
            return preVal.pk > curVal.pk ? preVal : curVal
          })
          let last_post_id = last_post.pk
          let key = ''
          if (circle_tag === 'common') {
            key = 'last_common_post_id'
            // SET_VALUE("last_common_post_id", last_post_id)
          } else if (circle_tag === 'work') {
            key = 'last_work_post_id'
            // SET_VALUE("last_work_post_id", last_post_id)
          } else if (circle_tag === 'science') {
            key = 'last_science_post_id'
            // SET_VALUE("last_science_post_id", last_post_id)
          } else if (circle_tag === 'move') {
            key = 'last_move_post_id'
            // SET_VALUE("last_move_post_id", last_post_id)
          } else if (circle_tag === 'mago') {
            key = 'last_mago_post_id'
            // SET_VALUE("last_mago_post_id", last_post_id)
          }else if(circle_tag === 'cube'){
            key = 'last_cube_post_id'
            // SET_VALUE("last_cube_post_id", last_post_id)
          }else if(circle_tag === 'contest'){
            key = 'last_contest_post_id'
            // SET_VALUE("last_contest_post_id", last_post_id)
          }else if(circle_tag === 'codeQA'){
            key = 'last_oj_post_id'
            // SET_VALUE("last_oj_post_id", last_post_id)
          }else if(circle_tag === 'video'){
            key = 'last_video_post_id'
            // SET_VALUE("last_video_post_id", last_post_id)
          }else if(circle_tag === 'piskel'){
            key = 'last_piskel_post_id'
            // SET_VALUE("last_piskel_post_id", last_post_id)
          }else if(circle_tag === 'lego'){
            key = 'last_lego_post_id'
            // SET_VALUE("last_lego_post_id", last_post_id)
          }
          
          if(key && (!GET_VALUE(key) || GET_VALUE(key) < last_post_id) ){
            SET_VALUE(key, last_post_id)
          }
        }
        dispatch(types.FETCH_NEW_ADD_POST_COUNT);
      }
    })
  },

  /**
   * 新建帖子/评论/回复事件
   * @param {*} param0 [commit]
   * @param {*} param_data [ {"type":"post", "content":"", "photos":"", "videos":"", "poster_url":""} ]
   */
  [types.FETCH_CREATE_EVENT] ({ dispatch, commit }, param_data) {
    let type = param_data.type
    var url = ''
    if (type === 'post') {
      url = URLS.create_post
    } else if (type === 'comment') {
      url = URLS.create_comment
    } else if (type === 'reply') {
      url = URLS.create_reply
    }

    // console.log(param_data)
    var message = ''
    if (type === 'post') {
      if (
        !param_data.content &&
        !param_data.photos &&
        !(param_data.videos || param_data.poster_url) &&
        !param_data.model_url
      ) {
        message = '文字、图片、视频、模型至少有一项必填'
      }
    } else if (!param_data.content) {
      message = '请输入一些内容'
    }
    if (message) {
      commit(TipTypes.SHOW, {
        message: message,
        submitCB: () => {
          commit(TipTypes.HIDE)
        }
      })
      return
    }
    let circle_tag = ROUTER.currentRoute.query.tag ? ROUTER.currentRoute.query.tag : 'scratch';

    if (type === 'post' && !param_data.content) {
      if (param_data.photos) {
        param_data['content'] = '分享图片'
        if(circle_tag === 'piskel'){
          param_data['content'] = '分享像素图'
        }
      } else if (param_data.videos) {
        param_data['content'] = '分享视频'
      } else if(param_data.model_url){
        param_data['content'] = '分享模型'
      }
    }
    if(type === 'post' && param_data.model_url){
      param_data['types'] = 'cube'
    }
    if(type === 'post' && param_data.videos && ['video', 'lego'].includes(circle_tag)){
        param_data['types'] = circle_tag
    }
    if(type === 'post' && circle_tag === 'piskel'){
      param_data["types"] = 'piskel'
    }

    POST(url, param_data).then(response => {
      if (type === 'post') {
        commit(LoadingTypes.HIDE)

        // 当前所处的圈子名是朋友圈的时候，更新最新帖子的 id，防止切到其他圈子，未读数变成 1
        // let circle_tag = ROUTER.currentRoute.query.tag ? ROUTER.currentRoute.query.tag : 'scratch';
        if(circle_tag === 'common' && response.types === 'common'){
          // 这里刷新列表有时不能即时显示出来，可以尝试用下延时或者，直接将返回的数据添加到数组中
          commit(types.LIST_POST_ADD_BEFORE, response)
          SET_VALUE("last_common_post_id", response.pk)
        }else if(circle_tag === 'cube' && response.types === 'cube'){
          commit(types.LIST_POST_ADD_BEFORE, response)
          SET_VALUE("last_cube_post_id", response.pk)
        }else if(circle_tag === 'video' && response.types === 'video'){
          commit(types.LIST_POST_ADD_BEFORE, response)
          SET_VALUE("last_video_post_id", response.pk)
        }else if(circle_tag === 'piskel' && response.types === 'piskel'){
          commit(types.LIST_POST_ADD_BEFORE, response)
          SET_VALUE("last_piskel_post_id", response.pk)
        }else if(ROUTER.currentRoute.name === 'company_detail' || ROUTER.currentRoute.name === 'school_detail'){
          commit(types.LIST_POST_ADD_BEFORE, response)
        }else if(circle_tag === 'lego' && response.types == 'lego'){
          commit(types.LIST_POST_ADD_BEFORE, response)
          SET_VALUE("last_lego_post_id", response.pk)
        }
      } else if(type === 'comment'){
        // 刷新某贴的评论数据
        commit("unshiftCommentData", {"data":response, "pk":param_data.post})
      } else if(type === 'reply') {
        // 刷新某贴的某评论的回复数据
        commit("unshiftReplyData", {"data":response, "post_id":param_data.post_id, "comment_id": param_data.comment})
      }
    })
  },

  // 点赞事件
  [types.FETCH_LIKE_EVENT] ({ dispatch, commit }, param_data) {
    let type = param_data.type
    var url = ''
    if (type === 'post') {
      url =
        param_data.is_like === true
          ? URLS.unlike_post(param_data.pk)
          : URLS.like_post(param_data.pk)
    } else if (type === 'comment') {
      url =
        param_data.is_like === true
          ? URLS.unlike_comment(param_data.pk)
          : URLS.like_comment(param_data.pk)
    } else if (type === 'reply') {
      url =
        param_data.is_like === true
          ? URLS.unlike_reply(param_data.pk)
          : URLS.like_reply(param_data.pk)
    }

    GET(url).then(response => {
      // 设置监听数据
      // response["type"] = type
      // commit('set_watch_zan_data', response)

      // 刷新列表
      commit(types.LOAD_LIKE_EVENT, param_data)
    })
  },

  // 删除事件
  [types.FETCH_DELETE_EVENT] ({ dispatch, commit }, param_data) {
    const deleteEvent = () => {
      let type = param_data.type
      var url = ''
      if (type === 'post') {
        url = URLS.delete_post(param_data.pk)
      } else if (type === 'comment') {
        url = URLS.delete_comment(param_data.pk)
      } else if (type === 'reply') {
        url = URLS.delete_reply(param_data.pk)
      }

      DELETE(url).then(response => {
        // 设置监听数据        
        // commit('set_watch_delete_data', param_data)

        // 刷新列表
        commit(types.LOAD_DELETE_EVENT, param_data)
      })
    }
    var dic = {
      content: '你确定要删除吗',
      submitCB: () => {
        console.log('点了确定')
        deleteEvent()
        commit(ConfirmTypes.HIDE)
      },
      cancelCB: () => {
        console.log('点了取消')
        commit(ConfirmTypes.HIDE)
      }
      // submitText: "YES",
      // cancelText: "NO"
    }
    commit(ConfirmTypes.SHOW, dic)
  },

  /**
   * 送花事件
   * @param {*} commit [ commit ]
   * @param {*} param_data [ {"pk":2, "receiver":"15201052252", "type":"post"} ]
   */
  [types.FETCH_FLOWER_EVENT] ({ dispatch, commit }, param_data) {
    var url = URLS.send_flower
    let data = { pk: param_data.pk, types: param_data.type }
    if (url !== '') {
      PUT(url, data).then(response => {
        // 设置监听数据
        // response["type"] = param_data.type
        // commit('set_watch_flower_data', response)

        // 刷新当前用户的鲜花数
        dispatch(LoginTypes.FETCH_UNREAD_MESSAGE)
        // 刷新帖子列表
        commit(types.LOAD_FLOWER_EVENT, param_data)
      })
    }
  },

  /**
   * 转发帖子到朋友圈事件
   * @param {*} commit [ commit ]
   * @param {*} param_data [ {"pk":2, "type":"post"} ]
   */
  [types.FETCH_FORWARD_EVENT] ({ dispatch, commit }, param_data) {
    let type = param_data.type
    var url = ''
    if (type === 'post') {
      url = URLS.forward_to_common_post
    }
    let data = { pk: param_data.pk }
    if (url !== '') {
      PUT(url, data).then(response => {
        commit(ToastTypes.SHOW, { message: '转发成功' })
      })
    }
  },

  /**
   * 关注/取关事件
   * @param {*} commit [ commit ]
   * @param {*} param_data [ {"type":"post", "is_follow":true, "followers":["15201052252"]} ]
   */
  [types.FETCH_FOLLOWERS_EVENT] ({ dispatch, commit }, param_data) {
    let url = param_data.is_follow ? URLS.remove_follows : URLS.add_follows
    let data = { 'followers': param_data.followers }
    PUT(url, data).then(response => {
      // 设置监听数据
      // commit('set_watch_follow_data', param_data)

      commit(LoginTypes.LOAD_FOLLOWER_EVENT, param_data);
      commit(types.LOAD_FOLLOWER_EVENT, param_data)
    })
  },

  /**
   * 帖子详情事件
   * @param {*} param0 [ commit ]
   * @param {*} param_data [ {pk:1} ]
   */
  [types.FETCH_POST_DETAIL] ({ dispatch, commit }, param_data) {
    let pk = param_data['pk']
    let url = URLS.detail_post(pk)
    commit(LoadingTypes.SHOW)
    GET(url).then(response => {
      response["comments"] = []
      response = deal_post_help(response)
      commit('setCurrentPost', response)
      commit(LoadingTypes.HIDE)
    })
  },

  /**
   * 评论列表事件
   * @param {*} param0 [commit]
   * @param {*} param_data [{"pk":1, "page":1}]
   */
  [types.FETCH_COMMENT_LIST] ({ dispatch, commit }, param_data) {
    let pk = param_data['pk']
    let pagenum = param_data['page']
    var url = URLS.list_comment(pagenum, pk)
    commit(LoadingTypes.SHOW)
    return new Promise((resolve, reject) => {
      GET(url).then(response => {
        response['page'] = pagenum
        response["pk"] = pk
        commit('setCommentData', response)
        commit(LoadingTypes.HIDE)
        resolve(response)
      })
    });
  },

  /**
   * 获取社区每日限玩时间
   * @param {*} param0
   * @param {*} param_data [ "update"，更新离开时间，其他则为不更新 ]
   */
  [types.FETCH_DAY_PLAY_TIME] ({ commit }, param_data) {
    PUT(URLS.day_play_time, { 'state': param_data }).then(response => {
      commit('setDayPlayTime', response)
    })
  },

  /**
   * 置顶事件
   * @param {*} commit [ commit ]
   * @param {*} param_data [ {"pk":2, "type":"post"} ]
   */
  [types.FETCH_STICKY_EVENT] ({ dispatch, commit }, param_data) {
    commit(LoadingTypes.SHOW)
    PUT(URLS.sticky_post(param_data.pk)).then(response => {
      commit('updateListSticky', response)
      commit(LoadingTypes.HIDE)
    })
  },

  /**
   * 出题事件
   * @param {*} param {"question_json":{}}
   */
  [types.FETCH_CREATE_QUESTION] ({ commit }, param) {
    commit(LoadingTypes.SHOW)
    POST(URLS.create_post, param).then(response => {
      commit(LoadingTypes.HIDE)
      // 这里刷新列表有时不能即时显示出来，可以尝试用下延时或者，直接将返回的数据添加到数组中
      commit(types.LIST_POST_ADD_BEFORE, response)
    })
  },

  /**
   * 答题事件
   * @param {*} param {"post_id":1, "user_answer":["A", "B"]}
   */
  [types.FETCH_ANSWER_QUESTION] ({ dispatch, commit }, param) {
    commit(LoadingTypes.SHOW)
    POST(URLS.create_post_answer_record, param).then(response => {
      commit(LoadingTypes.HIDE);
      // 更新帖子列表数据
      commit("update_some_post_list", response)
      if (response.is_right) {
        let msg = ""
        if (response.hasOwnProperty("diamond")) {
          msg = `恭喜你，获得${response.diamond}个蓝钻`
          // 更新用户的蓝钻数
          dispatch(LoginTypes.FETCH_UNREAD_MESSAGE)
        } else {
          msg = "恭喜你，答对了"
        }
        commit(TipTypes.SHOW, {
          tag: "answerRight",
          message: msg,
          submitCB: () => {
            commit(TipTypes.HIDE)
          }
        })
      }
    })
  },

  /**
   * 新增帖子条数事件
   */
  [types.FETCH_NEW_ADD_POST_COUNT] ({ commit }, param) {
    let dic = {}
    if (GET_VALUE("last_common_post_id")) {
      dic["last_common_post_id"] = GET_VALUE("last_common_post_id")
    }
    if (GET_VALUE("last_work_post_id")) {
      dic["last_work_post_id"] = GET_VALUE("last_work_post_id")
    }
    if (GET_VALUE("last_science_post_id")) {
      dic["last_science_post_id"] = GET_VALUE("last_science_post_id")
    }
    if (GET_VALUE("last_move_post_id")) {
      dic["last_move_post_id"] = GET_VALUE("last_move_post_id")
    }
    if (GET_VALUE("last_mago_post_id")) {
      dic["last_mago_post_id"] = GET_VALUE("last_mago_post_id")
    }
    if(GET_VALUE("last_cube_post_id")){
      dic["last_cube_post_id"] = GET_VALUE("last_cube_post_id")
    }
    if(GET_VALUE("last_contest_post_id")){
      dic["last_contest_post_id"] = GET_VALUE("last_contest_post_id")
    }
    if(GET_VALUE("last_oj_post_id")){
      dic["last_oj_post_id"] = GET_VALUE("last_oj_post_id")
    }
    if(GET_VALUE("last_company_id")){
      dic["last_company_id"] = GET_VALUE("last_company_id")
    }
    if(GET_VALUE("last_video_post_id")){
      dic["last_video_post_id"] = GET_VALUE("last_video_post_id")
    }
    if(GET_VALUE("last_piskel_post_id")){
      dic["last_piskel_post_id"] = GET_VALUE("last_piskel_post_id")
    }
    if(GET_VALUE("last_school_id")){
      dic["last_school_id"] = GET_VALUE("last_school_id")
    }
    if(GET_VALUE("last_lego_id")){
      dic["last_lego_id"] = GET_VALUE("last_lego_id")
    }


    PUT(URLS.new_add_post_count, dic).then(response => {
      commit("setNewPostCount", response);
    })
  },

  /**
   * 加精事件
   * @param {*} commit [ commit ]
   * @param {*} param_data [ {"pk":2, "type":"post"} ]
   */
  [types.FETCH_ESSENCE_EVENT] ({ dispatch, commit }, param_data) {
    commit(LoadingTypes.SHOW)
    PUT(URLS.essence_post(param_data.pk)).then(response => {
      commit('updateListEssence', response)
      commit(LoadingTypes.HIDE)
    })
  },

  /**
   * 视频帖子上首页事件
   * @param {*} commit [ commit ]
   * @param {*} param_data [ {"pk":2, "type":"post"} ]
   */
  [types.FETCH_HOME_VIDEO_EVENT] ({ dispatch, commit }, param_data) {
    commit(LoadingTypes.SHOW)
    PUT(URLS.home_video_post(param_data.pk)).then(response => {
      commit('updateListHomeVideo', response)
      commit(LoadingTypes.HIDE)
    })
  },

  /**
   * 回复列表事件
   * @param {*} param0 [commit]
   * @param {*} param_data [{"comment_id":1, "page":1, "post_id":1}]
   */
  [types.FETCH_REPLY_LIST] ({ dispatch, commit }, param) {
    // 打开等待动画
    commit(LoadingTypes.SHOW)
    let temp_dic = {
      data_type: "video"
    }
    commit('set_load_more', { ...temp_dic, value: false })
    commit('set_pagenum', { ...temp_dic, value: param.page })

    GET(URLS.list_reply(param.page, param.comment_id)).then(response => {
      // 跟新数据源
      response["comment_id"] = param.comment_id
      commit('setReplyData', response)

      // 移除等待动画
      commit(LoadingTypes.HIDE)

      if (response.next) {
        commit('set_load_more', { ...temp_dic, value: true })
      } else {
        commit('set_load_more', { ...temp_dic, value: false })
      }

      // 跟新数据源
      commit('set_list_data', {
        ...temp_dic,
        comment_id: param.comment_id,
        data: response.results,
        count: response.count
      })
    })

  },

  /**
   * 判断是否可以发帖事件
   * @param {*} param0 [ commit ]
   */
  [types.FETCH_IS_CAN_SEND] ({ dispatch, commit }, param) {
    return new Promise((resolve,reject)=>{
      commit(LoadingTypes.SHOW)
      GET(URLS.is_can_send).then(response => {
        commit("set_watch_can_send", {...param, ...response});
        commit(LoadingTypes.HIDE)
        resolve(response)
      })
    })
  },

  /**
   * 获取个人勋章列表
   */
  [types.FETCH_MY_MEDALS]({commit}, owner){
    GET(URLS.get_my_medals(owner)).then(response => {
      commit(types.LOAD_MY_MEDALS,response)
    })
  }
}

const getters = {
  dealPosts: state => posts => {
    var new_posts = []
    posts.map((item, index) => {
      let new_item = deal_post_help(item)
      new_posts.push(new_item)
    })

    // 对帖子排序
    new_posts = new_posts.sort(createCompareFunction('is_top'))
    return new_posts
  },
  [types.GETTER_LIST_POST] (state, getters, rootState, rootGetter) {
    return getters.dealPosts(state.posts)
  },

}

export default {
  state,
  mutations,
  actions,
  getters
}


// 帖子数据处理帮助方法
const deal_post_help = (item) => {
  let new_item = Object.assign({}, item)
  // 或
  // let new_item = {...item}
  if (new_item.photos) {
    new_item['images'] = new_item.photos.split(',')
  }
  return new_item
}

// 排序自定义方法
const createCompareFunction = (propertyName) => {
  return function (object1, object2) {
    var value1 = object1[propertyName]
    var value2 = object2[propertyName]
    if (value1 > value2) {
      return -1
    } else if (value1 < value2) {
      return 1
    } else {
      return 0
    }
  }
}
